import { useGetApiV1SerieSerieidLangs } from '@/shared/api/generated';

/** Itens por página da listagem de Idiomas da Série (paginação server-side). */
export const SERIE_LANG_PAGE_SIZE = 20;

/**
 * Hook para listar os Idiomas de uma Série, com paginação **server-side**.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serie/{serieId}/langs`.
 *
 * @param serieId - ID da série
 * @param page - Página atual (1-indexed)
 *
 * @example
 * ```tsx
 * const { langs, totalCount, isLoading } = useSerieLangList(serieId, page);
 * ```
 */
export function useSerieLangList(serieId: number, page: number) {
  const query = useGetApiV1SerieSerieidLangs(serieId, { page, pageSize: SERIE_LANG_PAGE_SIZE });

  return {
    langs: query.data?.data ?? [],
    totalCount: query.data?.totalCount ?? 0,
    totalPages: query.data?.totalPages ?? 1,
    currentPage: query.data?.currentPage ?? page,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
